"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zoppola": {
    "a845bc83": [{
      "hkey": "3595e3d9",
      "slug": "zoppola",
      "name": "Zoppola",
      "primary": true,
      "skipSearch": false
    }],
    "cevraia": [{
      "hkey": "3595e3d9",
      "slug": "zoppola",
      "name": "Zoppola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "58b04fd7": [{
      "hkey": "520d2ae8",
      "slug": "orcenico-inferiore-cusano",
      "name": "Orcenico Inferiore-Cusano",
      "primary": true,
      "skipSearch": false
    }],
    "cusano": [{
      "hkey": "520d2ae8",
      "slug": "orcenico-inferiore-cusano",
      "name": "Orcenico Inferiore-Cusano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "zoppola"
    }],
    "f07b1142": [{
      "hkey": "520d2ae8",
      "slug": "orcenico-inferiore-cusano",
      "name": "Orcenico Inferiore-Cusano",
      "primary": true,
      "skipSearch": false
    }],
    "orcenico-inferiore": [{
      "hkey": "520d2ae8",
      "slug": "orcenico-inferiore-cusano",
      "name": "Orcenico Inferiore-Cusano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4900057b": [{
      "hkey": "3595e3d9",
      "slug": "zoppola",
      "name": "Zoppola",
      "primary": true,
      "skipSearch": false
    }],
    "san-valentino": [{
      "hkey": "3595e3d9",
      "slug": "zoppola",
      "name": "Zoppola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;